import React from 'react';
import { Button } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

export type ContentLinkProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    className?: string;
};

function ContentLink({ className, ...props }: ContentLinkProps): React.JSX.Element {
    return <Button variant="link" className={cn('p-0', className)} {...props} />;
}

export default ContentLink;
